import SideBarShellSkeleton from './SideBarShellSkeleton';
import FullWidthShellSkeleton from './FullWidthShellSkeleton';
import { SkeletonFormCard } from './primitives';
import ContentTableSkeleton from './pages/ContentTableSkeleton';
import PodcastListSkeleton from './pages/PodcastListSkeleton';
import TextRowListSkeleton from './pages/TextRowListSkeleton';
import CardWrapSkeleton from './pages/CardWrapSkeleton';
import ProfileSkeleton from './pages/ProfileSkeleton';
import BillingSkeleton from './pages/BillingSkeleton';
import AIVoicesPageSkeleton from './pages/AIVoicesPageSkeleton';
import AudioAssetsPageSkeleton from './pages/AudioAssetsPageSkeleton';
import AnalyticsOverviewSkeleton from './pages/AnalyticsOverviewSkeleton';
import PlansSkeleton from './pages/PlansSkeleton';
import CreatePodcastSkeleton from './pages/CreatePodcastSkeleton';
import EditPodcastSkeleton from './pages/EditPodcastSkeleton';
import PlayerSkeleton from './pages/PlayerSkeleton';
import GeneralSettingsSkeleton from './pages/GeneralSettingsSkeleton';
import InstallationSkeleton from './pages/InstallationSkeleton';
import WelcomePageSkeleton from './pages/WelcomePageSkeleton';
import OnboardingSkeleton from './pages/OnboardingSkeleton';
import InstantVoiceCloneSkeleton from './pages/InstantVoiceCloneSkeleton';
import GenerationsPageSkeleton from './pages/GenerationsPageSkeleton';
import SavedProfilesSkeleton from './pages/SavedProfilesSkeleton';

// Route → skeleton shape, matched top to bottom by pathname. Studio editor, root ("/"),
// and dashboard routes are handled separately in App.js via BootLoadingScreen.
const ProjectCards = () => <CardWrapSkeleton cardHeight={200} />;
// Dubbing has 3 GenerationsTable columns (lang/status/format); Voice Changer/Isolator
// have 2 (duration/format) — see Dubbing.js vs VoiceChanger.js/VoiceIsolator.js.
const DubbingGenerations = () => <GenerationsPageSkeleton columns={3} />;
const VoiceToolGenerations = () => <GenerationsPageSkeleton columns={2} />;
const CenteredFormCard = () => <SkeletonFormCard fields={3} />;

const ROUTES = [
    // Full-width (no sidebar) routes
    { test: /\/integration$/, shell: 'fullwidth', Shape: ProjectCards }, // integration/project picker
    { test: /^\/profile$/, shell: 'fullwidth', Shape: ProfileSkeleton },
    { test: /^\/onboarding\//, shell: 'fullwidth', Shape: OnboardingSkeleton },
    { test: /\/welcome$/, shell: 'fullwidth', Shape: WelcomePageSkeleton },
    { test: /\/upgrade$|\/plans$/, shell: 'fullwidth', Shape: PlansSkeleton },

    // Sidebar-shell routes
    { test: /\/integration\/[^/]+\/(content|content-audio-articles)$/, shell: 'sidebar', Shape: ContentTableSkeleton },
    { test: /\/integration\/[^/]+\/podcast$/, shell: 'sidebar', Shape: PodcastListSkeleton },
    { test: /\/integration\/[^/]+\/podcast\/[^/]+\/episodes(-add)?$/, shell: 'sidebar', Shape: TextRowListSkeleton },
    { test: /\/integration\/[^/]+\/content_analytics$/, shell: 'sidebar', Shape: TextRowListSkeleton },
    { test: /\/integration\/[^/]+\/profiles$/, shell: 'sidebar', Shape: SavedProfilesSkeleton },
    { test: /\/integration\/[^/]+\/billing$/, shell: 'sidebar', Shape: BillingSkeleton },
    { test: /\/integration\/[^/]+\/voice$/, shell: 'sidebar', Shape: AIVoicesPageSkeleton },
    { test: /\/integration\/[^/]+\/(sound-effects|music)$/, shell: 'sidebar', Shape: AudioAssetsPageSkeleton },
    { test: /\/integration\/[^/]+\/analytics_overview$/, shell: 'sidebar', Shape: AnalyticsOverviewSkeleton },
    { test: /\/integration\/[^/]+\/podcast\/new$/, shell: 'sidebar', Shape: CreatePodcastSkeleton },
    { test: /\/integration\/[^/]+\/podcast\/[^/]+$/, shell: 'sidebar', Shape: EditPodcastSkeleton },
    { test: /\/integration\/[^/]+\/player$/, shell: 'sidebar', Shape: PlayerSkeleton },
    { test: /\/integration\/[^/]+\/general$/, shell: 'sidebar', Shape: GeneralSettingsSkeleton },
    { test: /\/integration\/[^/]+\/(installation|wordpress|cms|api)$/, shell: 'sidebar', Shape: InstallationSkeleton },
    { test: /\/integration\/[^/]+\/voice\/instant-voice-clone$/, shell: 'sidebar', Shape: InstantVoiceCloneSkeleton },
    { test: /\/integration\/[^/]+\/dubbing$/, shell: 'sidebar', Shape: DubbingGenerations },
    { test: /\/integration\/[^/]+\/(voice-changer|voice-isolator)$/, shell: 'sidebar', Shape: VoiceToolGenerations },

    { test: /.*/, shell: 'sidebar', Shape: CenteredFormCard }, // fallback for any other SideBarLayout route
];

export default function RouteSkeleton({ pathname }) {
    const match = ROUTES.find(r => r.test.test(pathname));
    const Shape = match?.Shape || CenteredFormCard;

    if (match?.shell === 'none') return <Shape />;

    const Shell = match?.shell === 'fullwidth' ? FullWidthShellSkeleton : SideBarShellSkeleton;

    return (
        <Shell>
            <Shape />
        </Shell>
    );
}
